<div class="modal-header zindex-modal">
  <h4 class="modal-title" id="modal-basic-title">
    {{header || "Confirmation"}}
  </h4>
  @if (showCloseButton) {
    <div (click)="activeModal.close(false)" class="close"><img
    src="../../../../assets/Images/organisation-structure/Cross.svg" alt="cross icon"></div>
  }
</div>
<div class="modal-body">
  <div>
    <h4  [ngClass]="lableName === 'Yes' ? 'text-danger' : ''"
      [innerHTML]="formattedMessage">{{!formattedMessage.trim() && 'Are you sure?'}}
    </h4>

    @if (showDropdown) {
      <div class="dropdown-container">
        <select  class="dropdownOptions" [formControl]="dropDownController">
          <option value="" disabled selected>Select an option</option>
          @for (item of dropdownOptions; track item) {
            <option  [value]="item.value">{{ item.label }}</option>
          }
          <option [value]="'Other'" >Other</option>
        </select>
      </div>
    }

    @if (stages.length) {
      <div class="dropdown-container">
        <select class="dropdownOptions" [formControl]="stageController">
          @for (stage of stages; track stage._id) {
            <option [value]="stage._id">{{ stage.name }}</option>
          }
        </select>
      </div>
    }

    @if (isConfirmationMessage || dropDownController.value === 'Other') {
      <app-description-field class="pt-3"
      placeholder="Reason" [control]="reason"></app-description-field>
    }

    @if (showInput) {
      <label>Document Number</label>
      <app-dynamic-form [formGroup]="metaDataForm" [documentNumberForm]="documentNumberForm"></app-dynamic-form>
    }

  </div>
</div>
<div class="modal-footer">
  <div class="text-right">
    <div class="d-flex justify-content-end">
      @if (showCancelButton) {
        <app-common-button class="m-1" buttonClass="smallbutton" [buttonLabel]="lableCancel || 'Cancel'"
          (click)="activeModal.close(false)">
        </app-common-button>
      }
      <app-common-button class="m-1" [disabled]="(isConfirmationMessageRequired || isDropdownSelectionReqired) && !(reason.value || dropDownController.value)" buttonClass="smallFilledButton" buttonLabel={{lableName}}
        (click)="successClose()">
      </app-common-button>
    </div>
  </div>
</div>